/**
 * features/clients/clientsWrite.ts
 * Writes for the clients collection. All go through the @/lib/firebase
 * wrappers, which strip undefined values before hitting Firestore.
 */
import { collection, doc } from 'firebase/firestore';
import { db, addDoc, updateDoc } from '@/lib/firebase';
import { COLLECTIONS, type Client } from '@/types';

export type ClientInput = Omit<Client, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>;

export async function createClient(input: ClientInput, actor: string): Promise<string> {
  const now = new Date().toISOString();
  const ref = await addDoc(collection(db, COLLECTIONS.clients), {
    ...input,
    createdAt: now,
    updatedAt: now,
    createdBy: actor,
  });
  return ref.id;
}

export async function updateClient(id: string, patch: Partial<ClientInput>): Promise<void> {
  await updateDoc(doc(db, COLLECTIONS.clients, id), {
    ...patch,
    updatedAt: new Date().toISOString(),
  });
}

export async function setClientActive(id: string, active: boolean): Promise<void> {
  await updateDoc(doc(db, COLLECTIONS.clients, id), {
    active,
    updatedAt: new Date().toISOString(),
  });
}
